import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * The start list used to be its own page. Since 2026-10-22 the meet is ONE
 * page that shows the start list until the meet goes live (the old OVR's
 * way, `components/console/meet-tab.ts`), so an old link lands on the meet.
 */
export const Route = createFileRoute("/_app/meets/$meetId/start-list")({
	beforeLoad: ({ params }) => {
		throw redirect({ to: "/meets/$meetId", params: { meetId: params.meetId }, replace: true });
	},
});
